import { ApplePayPaymentData } from './apple-pay-payment-data';
import { GooglePayPaymentData } from './google-pay-payment-data';

export type WalletPaymentData = ApplePayPaymentData | GooglePayPaymentData;
